import PropTypes from 'prop-types';
import React from 'react';
import { Wrapper, TabPanel, TabList, Tab } from 'react-aria-tabpanel';

import SearchResults from './search/results.jsx';
import Title from './title.jsx';
import Navbar from './navbar.jsx';
import SearchForm from './search_form.ui';

import badgeGoogle from '../assets/img/badges/badge-google-32x32.png';
import badgeDictionary from '../assets/img/badges/badge-dictionary-32x32.png';
import badgeTranslate from '../assets/img/badges/badge-google-translate-32x32.png';
import badgeWiki from '../assets/img/badges/badge-wikipedia-32x32.png';
import badgeYouTube from '../assets/img/badges/badge-youtube-32x32.png';

function searchSources(queryText) {
    return [
        {
            longName: 'Google',
            shortName: 'google',
            url: 'http://google.com/search?q=' + queryText,
            badge: badgeGoogle,
        },
        {
            longName: 'Dictionary',
            shortName: 'dictionary',
            url: 'http://dictionary.reference.com/browse/' + queryText,
            badge: badgeDictionary,
        },
        {
            longName: 'Google Translate',
            shortName: 'google-translate',
            url: 'http://translate.google.com/translate_t?hl=en&q=' + queryText,
            badge: badgeTranslate,
        },
        {
            longName: 'YouTube',
            shortName: 'youtube',
            url: 'http://www.youtube.com/results?search_query=' + queryText,
            badge: badgeYouTube,
        },
        {
            longName: 'Wikipedia',
            shortName: 'wikipedia',
            url:
                'http://en.wikipedia.org/wiki/Special:Search?search=' +
                queryText,
            badge: badgeWiki,
        },
    ];
}

export default class Search extends React.Component {
    static displayName = 'Search';

    static propTypes = {
        routeToSearch: PropTypes.func.isRequired,
        content: PropTypes.shape({
            title: PropTypes.string.isRequired,
        }),
        loadMore: PropTypes.func.isRequired,
        queryText: PropTypes.string.isRequired,
        context: PropTypes.string,
        contentResults: PropTypes.array,
        contentTotal: PropTypes.number,
        markupResults: PropTypes.array,
        markupTotal: PropTypes.number,
    };

    onSearch = (queryText, context) =>
        this.props.routeToSearch(queryText, context);

    renderExternalSearches(sources, queryText) {
        return sources.map(function(src) {
            const { shortName, longName, url, badge } = src;
            const className = 'search-badge ' + shortName + '-search';
            return (
                <li key={src.shortName} className={className}>
                    <a href={url} target="_blank" rel="noopener noreferrer">
                        <img src={badge} alt={longName} aria-hidden />
                        <span className="aural">
                            {`Search for "${queryText}" on ${longName} in a new window`}
                        </span>
                        <span aria-hidden="true">{longName}</span>
                    </a>
                </li>
            );
        });
    }

    renderSidebar(queryText) {
        const sources = searchSources(queryText);

        return (
            <div id="search-sidebar">
                <h1 className="aural">External searches for "{queryText}"</h1>
                <ul>{this.renderExternalSearches(sources, queryText)}</ul>
            </div>
        );
    }

    renderTabs(contentTotal, markupTotal) {
        return (
            <TabList>
                <ul className="tabs clearfix">
                    <li>
                        <Tab
                            id="content"
                            tag="button"
                        >{`Materials (${contentTotal})`}</Tab>
                    </li>
                    <li>
                        <Tab
                            id="markup"
                            tag="button"
                        >{`Notes (${markupTotal})`}</Tab>
                    </li>
                </ul>
            </TabList>
        );
    }

    render() {
        const {
            content,
            contentResults,
            contentTotal,
            markupResults,
            markupTotal,
            queryText,
            loadMore,
        } = this.props;

        // used to determine what element should get focus based on results length
        // contentResultsCount == 0, search input should get focus
        // contentResultsCount > 0, first link in results should get focus
        const contentResultsCount = contentResults.length;

        return (
            <Wrapper className="content-panel" id="search-results">
                <Title>Search results for "{queryText}"</Title>
                <Navbar.Proxy
                    title="Search"
                    showSearch={false}
                    isSearchResults={true}
                />
                <section className="header" role="search">
                    <SearchForm
                        onSearch={this.onSearch}
                        queryText={queryText}
                        content={content}
                        stealFocus={contentResultsCount == 0}
                    />
                    {this.renderTabs(contentTotal, markupTotal)}
                </section>
                <div className="tab-content">
                    <TabPanel tabId="content">
                        <SearchResults
                            loadMore={loadMore}
                            type="content"
                            total={contentTotal}
                            results={contentResults}
                            content={content}
                            stealFocus={contentResultsCount > 0}
                        />
                    </TabPanel>
                    <TabPanel tabId="markup">
                        <SearchResults
                            loadMore={loadMore}
                            type="markup"
                            total={markupTotal}
                            results={markupResults}
                            content={content}
                        />
                    </TabPanel>

                    {this.renderSidebar(queryText)}
                </div>
            </Wrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/search.ui.jsx